import React from "react";
import Menu from "./components/menu"
import Input from "./components/input"

function Main() {
  return (
      <div className="footer__main">
        <Input />
        <Menu />
      </div>
  );
}

export default Main;
